/// Position for locate the tooltip
var TooltipPosition;
(function (TooltipPosition) {
    TooltipPosition["TOP"] = "top";
    TooltipPosition["RIGHT"] = "right";
    TooltipPosition["BOTTOM"] = "bottom";
    TooltipPosition["LEFT"] = "left";
    TooltipPosition["LEFT_TOP"] = "left-top";
    TooltipPosition["LEFT_BOTTOM"] = "left-bottom";
    TooltipPosition["TOP_LEFT"] = "top-left";
    TooltipPosition["TOP_RIGHT"] = "top-right";
    TooltipPosition["TOP_CENTER"] = "top-center";
    TooltipPosition["RIGHT_TOP"] = "right-top";
    TooltipPosition["RIGHT_BOTTOM"] = "right-bottom";
    TooltipPosition["BOTTOM_LEFT"] = "bottom-left";
    TooltipPosition["BOTTOM_RIGHT"] = "bottom-right";
    TooltipPosition["BOTTOM_CENTER"] = "bottom-center";
    TooltipPosition["AUTO"] = "auto";
})(TooltipPosition || (TooltipPosition = {}));
const TOOLTIP_POSITIONS = TooltipPosition.AUTO;
/// Position for locate the modal
const MODAL_POSITIONS = 'center';
/// Enum with posible kinds of positions for the modal
var ModalPositionType;
(function (ModalPositionType) {
    ModalPositionType["TOP"] = "top";
    ModalPositionType["BOTTOM"] = "bottom";
    ModalPositionType["CENTER"] = "center";
    ModalPositionType["LEFT"] = "left";
    ModalPositionType["RIGHT"] = "right";
    ModalPositionType["TOP_LEFT"] = "top-left";
    ModalPositionType["TOP_RIGHT"] = "top-right";
    ModalPositionType["BOTTOM_LEFT"] = "bottom-left";
    ModalPositionType["BOTTOM_RIGHT"] = "bottom-right";
})(ModalPositionType || (ModalPositionType = {}));

export { MODAL_POSITIONS as M, TooltipPosition as T, TOOLTIP_POSITIONS as a };
